import Siteconf from './index';

export default { path: '/home/siteconf', component: Siteconf };
